var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"verification-shield",class:{ 'verification-shield--verified': _vm.verified }},[_c('i',{class:_vm.verified ? 'fa fa-shield-alt' : 'fa fa-shield-alt'})])
}
var staticRenderFns = []

export { render, staticRenderFns }